/** Arredonda valor monetário BRL para centavos (exigido pelo Mercado Pago e Pagar.me). */
export function roundMoney(value: number): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

/** Total do ingresso com taxa da plataforma opcional (valores sempre em centavos arredondados). */
export function calculateTicketTotalsWithFee(opts: {
  unitPrice: number;
  quantity?: number;
  feePercentage?: number;
  showPlatformFee?: boolean;
}): {
  baseTotal: number;
  feeAmount: number;
  total: number;
  showFee: boolean;
  feePercentage: number;
} {
  const q = Math.max(1, Math.floor(Number(opts.quantity) || 1));
  const unitPrice = roundMoney(Number(opts.unitPrice) || 0);
  const rawFeePct = Number(opts.feePercentage);
  const feePercentage =
    Number.isFinite(rawFeePct) && rawFeePct >= 0 ? rawFeePct : 6.9;
  const baseTotal = roundMoney(unitPrice * q);
  const showFee = !!(opts.showPlatformFee && unitPrice > 0);
  const feeAmount = showFee ? roundMoney((baseTotal * feePercentage) / 100) : 0;
  const total = showFee ? roundMoney(baseTotal + feeAmount) : baseTotal;

  return { baseTotal, feeAmount, total, showFee, feePercentage };
}
